<template>
  <div class="tool rounded" :class="{ big, middle, 'small-h': smallH, small }">
    <div class="tool__bg" :style="`background-image: url(${bgImageSrc}), url(${bgFillImageSrc})`"/>
    <!-- <img class="tool__bg" :src="bgImageSrc"/> -->
    <img class="tool__icon" :src="iconSrc"/>
    <div class="tool__header">
      <span class="tool__tag">{{tag}}</span>
      <h4 :class="['tool__title', { 'h2': big || middle, 'h3': smallH || small }]" v-html="$t(`routes.${route.name}`)"/>
    </div>
    <div class="tool__info">
      <p class="tool__text mb-1" v-html="$t(`products.tools.${route.name}`)"/>
      <b-btn variant="primary" size="sm" :to="{ name: route.name }">{{$t(`learn-more`)}}</b-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tool',
  props: {
    route: Object,
    tag: String,
    big: { type: Boolean, default: false },
    middle: { type: Boolean, default: false },
    smallH: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  computed: {
    iconSrc: app => require(`@/assets/${app.route.path}/${app.route.path}-icon.png`),
    bgImageSrc: app => require(`@/assets/${app.$toKebabCase(app.$route.name)}/tools/${app.route.path}.svg`),
    bgFillImageSrc: app => require(`@/assets/${app.$toKebabCase(app.$route.name)}/tools/${app.route.path}-bg.svg`)
  }
}
</script>

<style lang="sass" scoped>
.tool
  display: grid
  grid-template-columns: 95px minmax(0, 1fr)
  grid-gap: 19px 14px
  align-content: start
  padding: $spacer
  position: relative
  height: 100%
  border-radius: 4px
  background: $white
  overflow: hidden
  @media screen and (max-width: 480px)
    grid-template-columns: 60px minmax(0, 1fr)
    grid-gap: 10px 14px
    padding: $spacer * .75

  &.big
    aspect-ratio: auto
    grid-column-start: span 2
    grid-template-areas: 'icon .' 'header header' 'info info'
    @media screen and (max-width: 480px)
      aspect-ratio: auto

  &.middle
    aspect-ratio: 2
    grid-column-start: span 2
    grid-template-areas: 'icon header' 'info info'
    align-items: end
    +media-breakpoint-down(xs)
      aspect-ratio: auto

  &.small-h
    grid-column-start: span 2
    grid-template-areas: 'icon header' 'icon info'
    +media-breakpoint-down(xs)
      aspect-ratio: auto

  &.small-h &__text
    display: none

  &.small
    aspect-ratio: 1
    grid-template-areas: 'icon .' 'header header' 'info info'
    +media-breakpoint-down(xs)
      aspect-ratio: auto
    @media screen and (max-width: 480px)
      grid-column-start: span 2
      grid-template-areas: 'icon header' 'icon info'
      align-items: end
      align-content: end
      grid-template-rows: minmax(0, 1fr) auto

  &.small &__text
    display: none

  &__bg
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-repeat: no-repeat

    ~ *
      position: relative
      z-index: 1

  &.big &__bg,
  &.small &__bg
    background-position: center bottom -4%, center
    background-size: 104%, cover
    @media screen and (max-width: 480px)
      background-position: right center, center
      background-size: auto 106%, cover

  &.middle &__bg,
  &.small-h &__bg
    background-position: right -6% center, center
    background-size: auto 102%, cover

  &.big &__bg,
  &.middle &__bg
    @media screen and (max-width: 350px)
      background-position: center bottom -10%, center
      background-size: 100%, cover

  &__icon
    grid-area: icon
    width: 100%

  &__header
    grid-area: header

  &__title
    margin-bottom: 0
    +media-breakpoint-down(xs)
      font-size: 24px
    @media screen and (max-width: 480px)
      font-size: 18px

  &__tag
    font-size: 12px
    font-weight: bold
    letter-spacing: .8px
    text-transform: uppercase
    color: $purple

  &__info
    grid-area: info

    .btn
      padding: 0 10px
  &__text
    @media screen and (max-width: 480px)
      margin-top: -5px
      font-size: 13px
      line-height: 1.4
</style>



// WEBPACK FOOTER //
// src/components/ui/Tool.vue